import { render, staticRenderFns } from "./PrivateCompanyOffers.vue?vue&type=template&id=415377a1&scoped=true"
import script from "./PrivateCompanyOffers.vue?vue&type=script&lang=js"
export * from "./PrivateCompanyOffers.vue?vue&type=script&lang=js"
import style0 from "./PrivateCompanyOffers.vue?vue&type=style&index=0&id=415377a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "415377a1",
  null
  
)

export default component.exports